import { BasketIcon, ArrowRightIcon } from "@/components/data-display/Icon";
import classNames from "classnames";
import InlineLoader from "@/icons/inline-loader.svg";

function PetTagButton({ onClick, isLoading }) {
  return (
    <button
      className="bg-[#FCEE25] py-4  md:py-5 px-6 md:px-[30px] rounded-[20px] shadow-getPetTagButton flex items-center  border-[2px] border-[#050426] hover:bg-[#050426] hover:text-[#FCEE25] hover:border-[#FCEE25] transition-colors duration-700 group relative"
      onClick={onClick}
      disabled={isLoading}
    >
      {isLoading && (
        <InlineLoader className="inline-block h-[4rem] w-[4rem] absolute top-[calc(50%_-_2rem)] left-[calc(50%_-_2rem)]" />
      )}
      <div
        className={classNames(
          {
            invisible: isLoading,
          },
          "flex items-center gap-[1rem] md:gap-[1.125rem]"
        )}
      >
        <BasketIcon className="transition-colors duration-700 group-hover:text-[#FCEE25]" />
        <p className="text-xl md:text-2xl font-bold whitespace-nowrap">
          Get Your Pet Tag Now
        </p>
        <ArrowRightIcon className="transition-colors duration-700 group-hover:text-[#FCEE25]" />
      </div>
    </button>
  );
}

export default PetTagButton;
